import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';

import { environment } from './http/environment';

import { Confirmation } from './confirmation/confirmation';

export interface CybersourcePayload {
   access_key: string;
   profile_id: string;
   transaction_uuid: string;
   signed_date_time: string;

   locale: string;
   transaction_type: string;

   amount: string;
   currency: string;

   reference_number: string;

   signed_field_names: string[];
   unsigned_field_names: string[];

   signature: string;
}

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

   url = environment.origin;

   constructor(
      private http: HttpClient,
   ) {}

   getSignature( payload ): Observable<CybersourcePayload> {
      return this.http.post<CybersourcePayload>( this.url + 'signature', payload );
   }

   getDetails( uuid: string ): Observable<Confirmation> {
      return this.http.get<Confirmation>( this.url + 'confirmation/' + uuid );
   }

   sendEmail( payload ): Observable<boolean> {
      return this.http.post<boolean>( this.url + 'confirmation/email', payload );
   }
}
